module.exports = __webpack_public_path__ + "static/images/23f5504f1dab956bba4007afd577448e.png";